import {ErrorRounded} from '@material-ui/icons';
import React from 'react';

export function ErrorIcon() {
  return <ErrorRounded fontSize="small" color="error" />;
}
